<template>
  <z-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <div
      class="box"
      :style="{
        background:
          applyList.length === 0 && reportApplyList.length === 0 ? '#fff' : 'rgb(248, 248, 248)',
      }"
    >
      <z-list key="now" v-model="loading" :finished="finished" finished-text="" :error.sync="error">
        <section>
          <div
            class="header"
            v-if="!loading && !(applyList.length === 0 && reportApplyList.length === 0)"
          >
            以下订单可直接提交赔付申请
          </div>
          <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
          <div v-if="!loading && applyList.length > 0">
            <product-card
              v-for="(item, index) in applyList"
              :key="index"
              :process="process"
              :applySource="applySource"
              :data="item"
              cardType="order"
              :certification="certification"
            />
          </div>
        </section>
      </z-list>

      <z-stance
        v-if="!loading && applyList.length === 0 && reportApplyList.length > 0"
        type="general"
        :show-info="false"
        descText="暂无在保护期内可申请赔付的订单"
        :show-btn="
        applySource === 'securitycenter' &&
          !loading &&
          !loadingHistory &&
          applyList.length === 0 &&
          reportApplyList.length === 0
      "
        btn-text="去逛逛"
        @click="toHome()"
      />

      <z-stance
        v-if="!loading && !loadingHistory && applyList.length === 0 && reportApplyList.length === 0"
        type="general"
        :show-info="false"
        descText="还没有保护期内的订单哦~"
        :show-btn="applySource === 'securitycenter' &&
          !loading &&
          !loadingHistory &&
          applyList.length === 0 &&
          reportApplyList.length === 0"
        btn-text="去逛逛"
        @click="toHome()"
      />
      <z-icon v-show="false" name="passed" size="1.06rem" color="#ff5555" />
      <z-list
        key="history"
        v-if="!toUid && reportApplyList.length > 0"
        v-model="loadingHistory"
        :finished="finishedHistory"
        finished-text=""
        :error.sync="errorHistory"
        @load="onLoadHistory"
      >
        <section>
          <div class="header">以下订单如想申请赔付，请先进行举报</div>
          <product-card
            v-for="(item, index) in reportApplyList"
            :key="index"
            :data="item"
            cardType="report"
            :certification="certification"
          />
        </section>
      </z-list>
    </div>
    <!-- <z-button-group
      v-show="
        applySource === 'securitycenter' &&
          !loading &&
          !loadingHistory &&
          applyList.length === 0 &&
          reportApplyList.length === 0
      "
    >
      <z-button type="primary" btn-class="bottombtn" @click="toHome()">去逛逛</z-button>
    </z-button-group> -->
  </z-pull-refresh>
</template>

<script>
import native from '@zz-common/native-adapter'
import { List, Icon, PullRefresh, Stance } from '@zz-common/zz-ui'
// import DAL from '../../../../dal'
// import { lego } from '@zz-common/lego'
import productCard from '../product-card'
import { getPayMoneyReportList, getPayMoneyOrderList } from '../../../../api/resourceApi'

export default {
  name: 'select-pay',
  props: {
    identity: String,
    toUid: String,
    active: Number,
    applySource: String
  },
  data() {
    return {
      applyList: [],
      error: false,
      loading: false,
      finished: true,
      refreshing: false,
      reportApplyList: [],
      errorHistory: false,
      loadingHistory: false,
      finishedHistory: false,
      refreshingHistory: false,
      expend: false,
      fetch: false,
      process: false, //申请是否进行中
      certification: false, //是否需要实人认证
      pageNum: 1,
      status: 1 // 0正常 1 不正常
    }
  },
  components: {
    zPullRefresh: PullRefresh,
    zList: List,
    zIcon: Icon,
    zStance: Stance,
    productCard
  },
  methods: {
    onLoadHistory(isRefresh) {
      if (isRefresh) {
        this.reportApplyList = []
      }
      this.loadingHistory = true
      this.getCheckHistyory()
    },
    async getCheckHistyory() {
      const params = {
        identity: this.identity,
        applySource: this.applySource,
        pageNum: this.pageNum++
      }
      const res = await getPayMoneyReportList(params)
      const { reportApplyList = [] } = res
      this.loadingHistory = false // 加载状态结束
      console.log(res)
      if (reportApplyList.length <= 0) {
        this.finishedHistory = true
        return
      }
      this.reportApplyList.push(...reportApplyList)
    },
    onLoad(isRefresh) {
      if (isRefresh) {
        this.applyList = []
      }
      this.loading = true
      this.getCheck()
      // this.loading = false;// 加载状态结束
    },
    async getCheck() {
      const params = {
        identity: this.identity,
        applySource: this.applySource,
        toUid: this.toUid
      }
      const res = await getPayMoneyOrderList(params)
      const { applyList = [], certification, process } = res
      console.log('certification', certification)
      console.log('process', process)

      this.loading = false
      this.applyList = applyList
      this.certification = certification
      this.process = process
      this.fetch = true
    },
    onRefresh() {
      this.status = 1
      this.onLoad(true)
      this.finishedHistory = false
      this.pageNum = 1
      if (!this.toUid) this.onLoadHistory(true)
      setTimeout(() => {
        this.refreshing = false
      }, 500)
    },
    handleVisiable(e) {
      if (e.target.visibilityState === 'visible') {
        console.log('我回来了')
        if (this.active === 0 && this.identity === 'buyer') {
          this.onRefresh()
        }
        if (this.active === 1 && this.identity === 'seller') {
          this.onRefresh()
        }
      }
    },
    toHome() {
      const targetUrl = 'zhuanzhuan://jump/core/mainPage/jump?tabId=0'
      native.skipToUrl({
        targetUrl
      })
    }
  },
  mounted() {
    this.onLoad()
    if (!this.toUid) this.onLoadHistory()
    document.addEventListener('visibilitychange', this.handleVisiable)
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
